import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchRecentActivities } from '../../utilities/dashboardServices'
import { toast } from 'react-toastify'

export const fetchUsersActivities = createAsyncThunk(
    'users/fetchRecentActivities', fetchRecentActivities
)

const initialState = {
    value: [{
        applicationID: "--",
        fullName: "--",
        appStatus: "--",
    }],
}

const recentActivitiesSlice = createSlice({
    name: 'recentActivities',
    initialState,
    reducers: {
        resetRecentActivities: (state) => {
            // toast.success("RecentActivities reseted Successfully")
            state.value = [{
                applicationID: "--",
                fullName: "--",
                appStatus: "--",
            }]
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsersActivities.pending, (state, action) => {
                // toast.warn("RecentActivities pending")
            })
            .addCase(fetchUsersActivities.fulfilled, (state, action) => {
                let arr = []
                action.payload.length > 0 && action.payload.map((data) => {
                    let value = {
                        applicationID: data.ApplicationID || "--",
                        fullName: data.PatientName || "--",
                        appStatus: data.ActionDescription || "--",
                    }
                    arr.push(value)
                    state.value = arr
                })
                // toast.success("RecentActivities Fetched Successfully")
            })
            .addCase(fetchUsersActivities.rejected, (state, action) => {
                toast.error(action.error.message)
            })
    },
})

export const { resetRecentActivities } = recentActivitiesSlice.actions

export const recentActivities = state => state.recentActivitiesSlice.value
export default recentActivitiesSlice.reducer